module.exports = __webpack_public_path__ + "static/media/Strategic_Icon.90cb584b.svg";